import { Component, Input, OnInit } from '@angular/core';
import { DataService } from '../../../services/data.service';

@Component({
  selector: 'strategy-wrapper',
  templateUrl: './wrapper.component.html',
  styleUrls: ['./wrapper.component.scss']
})
export class WrapperComponent implements OnInit {

  constructor(private dataService: DataService) { }

  strategy_name: string = '';
  params: any = {};
  
  ngOnInit(): void {
    this.dataService.onStrategyDetailsPopulating.subscribe(data => {
      this.params = data;
      this.strategy_name = this.params.strategyParams.code;
    });
    this.dataService.onStrategyDetailsSaved.subscribe(data => {
      this.resetDefaults();
    });
  }

  resetDefaults() {
    this.params = {};
    this.strategy_name = '';
  }
}
